<!-- Page Title -->
<div class="page-title-area" [ngStyle]="{ 'background-image': 'url(' + introImage + ')' }">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <h1 i18n="@@introTitle">Discover the services community that gets the work done</h1>
      </div>
    </div>
  </div>
  <div class="shape2 rotateme"><img src="assets/img/shapes/shape2.svg" alt="shape" /></div>
  <div class="shape3"><img src="assets/img/shapes/shape3.svg" alt="shape" /></div>
  <div class="shape4"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape5"><img src="assets/img/shapes/shape5.png" alt="shape" /></div>
  <div class="shape6 rotateme"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape7"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape8 rotateme"><img src="assets/img/shapes/shape2.svg" alt="shape" /></div>
</div>

<!-- Content -->
<!-- About -->
<div class="about-area ptb-80">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="about-image">
          <img
            src="https://cdn.sanity.io/images/jizm7zxy/production/129dc2abd6d54f0163c7f75f9637fed9c4c965bc-2701x2001.png?fm=webp&q=75"
            alt="image"
          />
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="about-content">
          <div class="section-title">
            <h2 i18n="@@aboutWipperozSubtitle">About Wipperoz</h2>
            <div class="bar"></div>
          </div>
          <div i18n="@@aboutWipperozText">
            <p>
              Wipperoz is a platform designed to enhance connections between people. On our site you can quickly contact
              professional services or people for different tasks, whether in person or remotely.
            </p>

            <p>
              We connect customers with suppliers. We call customer to any person who posts a job application and
              requires the services of a professional. We call that post "Wip" and we consider every person as a
              potential supplier.
            </p>
            <p>
              Our platform is designed to make it easy for each customer to find a supplier and request a professional
              for a specific job. At the same time, we think of making it easier for suppliers to find these offers,
              through a labeling and notification system, but also with a search engine.
            </p>
            <p>
              We are a platform that combines the possibility of contacts for remote and face-to-face work. This is
              possible thanks to the incorporation of a geolocation option, which allows you to indicate whether the
              search is for remote jobs, for a certain geographic radius, or for both alternatives.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="about-inner-area">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="about-text">
            <h3 i18n="@@ourVisionTitle">Vision</h3>
            <p class="text-justify" i18n="@@ourVision">
              We believe in technology as an essential tool to optimize management processes, stimulate and generate new
              sources of genuine work and establish cooperation ties. That is why we see the promotion of digital
              education as a key component to achieve greater inclusion and social development.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="about-text">
            <h3 i18n="@@ourMissionTitle">Mission</h3>
            <p class="text-justify" i18n="@@ourMission">
              Our mission is to speed up the encounter between those who are looking for a person to carry out a task
              and those who can offer that solution or professional service. We see technology as a powerful resource to
              boost labor and collaboration relationships, whether in person or remotely, which is why we work for
              education and digital inclusion in different sectors, providing tools that optimize the management of
              their daily tasks.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="about-text">
            <h3 i18n="@@ourValuesTitle">Values</h3>
            <ul class="text-justify" i18n="@@ourValues">
              <li>Resilience, adapt to changes.</li>
              <li>
                Empathy, to contribute to the humanization of technology and to establish it as an effective value for
                social development.
              </li>
              <li>Collaborative spirit, in the conviction that synergy enhances human work.</li>
              <li>Responsibility and commitment to our community.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-join-today></app-join-today>
<app-wipperoz-numbers></app-wipperoz-numbers>
